<template>
  <div id="divLanguage" class="language-switcher" @click.stop="toggleDropdown">
    <!-- Botão principal -->
    <div class="flag-button">
      <img :src="currentFlag" class="flag-icon" />
      <span class="flag-label">{{ $t(currentTitle) }}</span>
      <i class="bi bi-chevron-down"></i>
    </div>

    <!-- Dropdown -->
    <transition name="fade">
      <div v-if="open" class="dropdown">
        <div
          class="dropdown-item"
          v-for="lang in languages"
          :key="lang.value"
          @click.stop="changeLanguage(lang.value)"
        >
          <img :src="lang.avatar" class="flag-icon-small" />
          <span>{{ $t(lang.title) }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import flagBr from "@/assets/bandeiras/icon-flag-pt.svg";
import flagEs from "@/assets/bandeiras/icon-flag-es.svg";
import flagEn from "@/assets/bandeiras/icon-flag-en.svg";
import flagFr from "@/assets/bandeiras/icon-flag-fr.svg";
import flagGe from "@/assets/bandeiras/icon-flag-ge.svg";
import flagHo from "@/assets/bandeiras/icon-flag-ho.svg";
// import flagRo from "@/assets/images/flag/icon-flag-ro.svg";
// import flagZh from "@/assets/images/flag/icon-flag-zh.svg";

export default {
  data() {
    return {
      open: false,
      languages: [
        { title: "Portugues", value: "pt", avatar: flagBr },
        { title: "Espanhol", value: "es", avatar: flagEs },
        { title: "Ingles", value: "en", avatar: flagEn },
        { title: "Frances", value: "fr", avatar: flagFr },
        { title: "Alemao", value: "ge", avatar: flagGe },
        { title: "Holandes", value: "ho", avatar: flagHo }
      ]
    };
  },

  computed: {
    currentFlag() {
      const lang = this.languages.find(l => l.value === this.$i18n.locale);
      return lang ? lang.avatar : this.languages[0].avatar;
    },
    currentTitle() {
      const lang = this.languages.find(l => l.value === this.$i18n.locale);
      return lang ? lang.title : this.languages[0].title;
    }
  },

  mounted() {
    // Fecha dropdown se clicar fora
    document.addEventListener("click", this.closeOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeOutside);
  },

  methods: {
    toggleDropdown() {
      this.open = !this.open;
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      this.open = false;

      const idiomaSelecionado = {
        lang: lang
      }
      localStorage.lang = JSON.stringify(idiomaSelecionado)
    },
    closeOutside() {
      this.open = false;
    }
  }
};
</script>

<style scoped>
.language-switcher {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.flag-button {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 12px;
  border-radius: 20px;
  border: 1px solid var(--rd-border);
  background: var(--rd-bg-1);
  color: var(--rd-text-2);
}

.flag-button:hover {
  border-color: var(--rd-border-strong);
  color: var(--rd-text-1);
}

.flag-icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  object-fit: cover;
}

.flag-label {
  font-size: 12px;
}

.dropdown {
  position: absolute;
  top: 42px;
  right: 0;
  background: var(--rd-bg-2);
  border: 1px solid var(--rd-border-strong);
  border-radius: var(--rd-radius-sm);
  padding: 6px;
  width: 160px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  z-index: 10;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  color: var(--rd-text-2);
  transition: background 0.2s;
  font-size: 12.5px;
}

.dropdown-item:hover {
  background: var(--rd-hover);
  color: var(--rd-text-1);
}

.flag-icon-small {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}

/* Transição fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
